<div class="body">

    <ng-container *ngIf="!(loading|async); else loadingContainer">

        <div class="content" *ngIf="issueHistoryDialogComponentService.audit.length > 0; else noAuditEntries" [@list]="issueHistoryDialogComponentService.audit.length">

            <ng-container *ngFor="let entry of issueHistoryDialogComponentService.audit; let i = index">
    
                <div class="entry-wrapper">
    
                    <app-issue-audit-wrapper [wrapper]="entry" [isFirstEntry]="i === 0" [isLastEntry]="i === (issueHistoryDialogComponentService.audit.length - 1)"></app-issue-audit-wrapper>
    
                </div>
    
            </ng-container>
    
        </div>

    </ng-container>

    <div class="footer">

        <div class="text-wrapper">

            {{issueHistoryDialogComponentService.audit.length}} von {{issueHistoryDialogComponentService.totalCount}}

        </div>

        <button mat-raised-button color="primary" (click)="loadMore()" [disabled]="issueHistoryDialogComponentService.audit.length >= issueHistoryDialogComponentService.totalCount">
            Mehr laden
        </button>

        <button mat-raised-button color="warn" (click)="close()">
            Schließen
        </button>

    </div>

</div>

<ng-template #loadingContainer>

    <div class="loading-wrapper">

        <mat-spinner [diameter]="100"></mat-spinner>

    </div>

</ng-template>

<ng-template #noAuditEntries>

    <div class="content no-entries-hint" @fade>

        Keine Einträge

    </div>

</ng-template>
